/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { arrayOf, entity, file } from '@gh/core-data';
import { ImportPriceApplyItemDto } from './import-price-apply-item.dto';
import { ImportPriceBatchIdDto } from './import-price-batch-id.dto';
import { ImportPriceFileItemDto } from './import-price-file-item.dto';
import { ImportPriceItemsCountDto } from './import-price-items-count.dto';

export const ImportPriceFileItemMapper = entity<ImportPriceFileItemDto>();
export const ImportPriceFileMapper = file();
export const ImportPriceItemsCountMapper = entity<ImportPriceItemsCountDto>();
export const ImportPriceBatchIdMapper = entity<ImportPriceBatchIdDto>({
  counts: arrayOf(ImportPriceItemsCountMapper),
});
export const ImportPriceApplyItemMapper = entity<ImportPriceApplyItemDto>();
